<template>
<div class="newsletter-subscribe" v-if="can_subscribe">
  <div class="newsletter-subscribe__header">
    <p>The best roles straight to your inbox, weekly.</p>
  </div>

	<div class="email-subscribe">

    <div class="email-subscribe__container">
      <input v-if="!me" :class="['email-subscribe__input', {'error':errors.length}]" placeholder="Email" @keyup.enter="doSubscribe" v-model.trim="email" required/>

      <p v-if="errors.length" class="error">{{ errors[0] }}</p>

      <button class="email-subscribe__button" @click="doSubscribe" aria-label="Newsletter Subscribe">
        <block-spinner :active="isLoading" size="5" color="text-white" class="absolute"></block-spinner>
        <span :class="[{'opacity-0':isLoading}]">{{ btn_title }}</span>
      </button>
    </div>

  </div>

</div> 
</template>

<script>
import NewsletterMixins from '@/mixins/NewsletterMixins';

export default {
	mixins: [NewsletterMixins],

  props: {
    btn_title: {
      type: String,
      default: 'Subscribe'
    }
  },

  data() {
		return {
			newsletter: "Top 10 Opportunities"
		}
	}
}
</script>
